import { api } from '@/http/constants';
import fetchWrapper from '@/http/fetchWrapper';
import type {
  MfaProofChallengeRequest,
  MfaProofChallengeResponse,
} from '@eye-able/types';
import { useMutation } from '@tanstack/react-query';
import { toMfaError } from './mfaError';

/**
 * Password (and a current code, once a method is active) in exchange for the
 * challenge the setup routes want. A stolen session alone adds no method.
 */
export function useProveIdentity() {
  return useMutation({
    gcTime: 0,
    mutationFn: (body: MfaProofChallengeRequest) =>
      fetchWrapper
        .post<MfaProofChallengeResponse>(api.mfaProof, body)
        .catch((error: unknown) => {
          throw toMfaError(error);
        }),
  });
}
